// Noodle & Snoot: carousel continuous auto-scroll/loop script.
// Isolated into this static asset file 1 August 2026 as part of the
// Dawn-update isolation refactor (see Protected Custom Code Registry,
// item 5). Previously embedded directly in
// sections/featured-collection.liquid, which is exactly the kind of
// file a Dawn theme-engine update can silently overwrite (confirmed
// missing entirely from the 31 July 2026 Dawn 15.5.0 update draft).
//
// Architecture note: the original version used Liquid-templated
// section.id ({{ section.id }}) to find its target element. Liquid
// tags are never evaluated inside a static asset file, so that
// approach can't be ported verbatim. Instead, the section file now
// adds a plain "ns-carousel-autoscroll" marker class to its own
// <slider-component> element (a single class name, trivial to
// restore even if a merge drops it), and this script discovers its
// target generically by that class rather than by an injected ID.
// Only the marker class and a single <script src> reference now live
// in the section file; the actual logic lives here, safe from merges.
//
// Fixed 1 August 2026 (same session as the isolation move): the
// original had a known open bug where it cloned slides into the loop
// buffer regardless of whether the section was actually in slider
// mode (show_mobile_slider or show_desktop_slider). When the
// carousel-tagged product count dropped to columns_desktop or fewer,
// the Liquid renders a plain wrapping grid, not a slider, but the old
// script still doubled every card into an ugly duplicate row. Fixed
// by having the section file expose that Liquid-computed boolean via
// a "data-ns-slider-active" attribute on the same marker element
// (one attribute, trivial to restore, same isolation philosophy as
// the marker class itself), and gating the clone/scroll logic on it
// below. Everything else is unchanged from the original.
(function () {
  function setupCarousel(sliderComponent) {
    // Guard against double-initialisation if this section renders
    // more than once on the same page.
    if (sliderComponent.dataset.nsCarouselInitialized) return;
    sliderComponent.dataset.nsCarouselInitialized = 'true';

    var slider = sliderComponent.querySelector('ul[id^="Slider-"]');
    if (!slider) return;

    // Hide the slide counter (only present at all when slider mode is
    // active, per the section's own Liquid, but guard anyway)
    var slideCounter = sliderComponent.querySelector('.slider-counter');
    if (slideCounter) {
      slideCounter.style.display = 'none';
    }

    // Bug fix, 1 August 2026: don't clone/scroll at all unless the
    // section is genuinely in slider mode. Previously this ran
    // unconditionally, so a low tagged-product count (section renders
    // as a plain grid, no "slider" class on the <ul>) still got its
    // cards doubled into a static duplicate row.
    if (sliderComponent.dataset.nsSliderActive !== 'true') return;

    var slides = Array.from(slider.querySelectorAll('.grid__item'));
    if (slides.length <= 1) return;

    // Detect mobile
    var isMobile = window.innerWidth < 768;

    // Different speeds for mobile vs desktop
    var scrollSpeed = isMobile ? 1.2 : 0.8; // Faster on mobile
    var isPaused = false;
    var animationFrame;

    // Clone all slides for seamless loop
    slides.forEach(function (slide) {
      var clone = slide.cloneNode(true);
      slider.appendChild(clone);
    });

    // Remove any scroll snap or smooth behaviour
    slider.style.scrollBehavior = 'auto';
    slider.style.scrollSnapType = 'none';

    function continuousScroll() {
      if (!isPaused) {
        slider.scrollLeft += scrollSpeed;

        // Get the midpoint (where clones start)
        var resetPoint = slider.scrollWidth / 2;

        // Reset with a small buffer to make the jump less noticeable
        if (slider.scrollLeft >= resetPoint - 1) {
          slider.scrollLeft = slider.scrollLeft - resetPoint;
        }
      }

      animationFrame = requestAnimationFrame(continuousScroll);
    }

    // Pause on hover (desktop)
    slider.addEventListener('mouseenter', function () {
      isPaused = true;
    });

    slider.addEventListener('mouseleave', function () {
      isPaused = false;
    });

    // Pause on touch (mobile)
    slider.addEventListener('touchstart', function () {
      isPaused = true;
    });

    slider.addEventListener('touchend', function () {
      setTimeout(function () {
        isPaused = false;
      }, 500); // Brief delay before resuming
    });

    // Update speed on resize
    window.addEventListener('resize', function () {
      isMobile = window.innerWidth < 768;
      scrollSpeed = isMobile ? 1.2 : 0.8;
    });

    // Start continuous scrolling
    continuousScroll();

    // Respect reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      cancelAnimationFrame(animationFrame);
    }

    // Clean up on page unload
    window.addEventListener('beforeunload', function () {
      cancelAnimationFrame(animationFrame);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ns-carousel-autoscroll').forEach(setupCarousel);
  });
})();
